import { createdListKey } from "./recentlyCreated";
import type { Portfolio } from "@/types/Portfolio";
import type { TagsWatchlist } from "@/shared/api/pref-storage/tags-watchlists";
import type { CategoryQuery } from "@/widget-components/newsquawk-headlines/models/CategoryQuery";
import type { EditableWatchlist } from "./hooks/useWatchlistCreator";

/**
 * Rows for the builder's two lists (components/ListParts), from any of the
 * three stores a watchlist can live in.
 */

export type ListEntry = {
  /** Unique across all three stores; see `createdListKey`. */
  key: string;
  name: string;
  combined: boolean;
  item: EditableWatchlist;
};

export const portfolioEntry = (p: Portfolio): ListEntry => ({
  key: createdListKey("watchlist", p.id),
  name: p.name,
  combined: false,
  item: { kind: "watchlist", portfolio: p },
});

export const tagWatchlistEntry = (w: TagsWatchlist): ListEntry => ({
  key: createdListKey("tag", w.id),
  name: w.name,
  combined: false,
  item: { kind: "tag", watchlist: w },
});

export const combinedEntry = (q: CategoryQuery & { id: number }): ListEntry => ({
  key: createdListKey("combined", q.id),
  name: q.queryName,
  combined: true,
  item: { kind: "combined", query: q },
});

const collator = new Intl.Collator(undefined, {
  sensitivity: "base",
  numeric: true,
});

export const byName = (a: ListEntry, b: ListEntry) =>
  collator.compare(a.name, b.name);

export const matches = (entry: ListEntry, query: string) =>
  !query || entry.name.toLowerCase().includes(query);

